import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { useToggle } from '../../hooks/useToggle';
import { Input } from '../../types/Input';
import { Box } from '../Box/Box';
import { IconButton } from '../IconButton/IconButton';
import { TextInput } from '../TextInput/TextInput';

export const PasswordInput = memo((props: Input<string>) => {
  const [isVisible, toggleIsVisible] = useToggle(false);
  const intl = useIntl();

  return (
    <Box styles={componentStyles.container}>
      <TextInput {...props} type={isVisible ? 'text' : 'password'} />
      <Box styles={componentStyles.icon}>
        <IconButton
          icon={isVisible ? 'not-visible' : 'view'}
          size="s"
          tooltip={
            isVisible
              ? intl.formatMessage({
                  id: 'PasswordInput.hidePassword',
                  defaultMessage: 'Hide password',
                  description: 'Tooltip for hiding password',
                })
              : intl.formatMessage({
                  id: 'PasswordInput.showPassword',
                  defaultMessage: 'Show password',
                  description: 'Tooltip for showing password',
                })
          }
          onClick={toggleIsVisible}
        />
      </Box>
    </Box>
  );
});

// TODO EKP-18796: formalize `leftIcon`, `rightIcon` in `BaseInput` component.
export const componentStyles = {
  container: {
    minWidth: 'max-content',
    position: 'relative',
    '> input': {
      paddingRight: 12, // hardcoded use of "!important" but still preferable to overloading TextInput
    },
  },
  icon: {
    alignItems: 'center',
    bottom: 0,
    display: 'flex',
    position: 'absolute',
    right: 2,
    top: 0,
  },
};
